export const query_user_permission = `
query getUserPermission($userId: String!, $aziendaId: Int!, $area: String!) {
  user_permission(where: {UserId: {_eq: $userId}, AziendaId: {_eq: $aziendaId}, Area: {_eq: $area}}) {
    Id
    AziendaId
    Area
    CanRead
    CanCreate
    CanUpdate
    CanDelete
  }
}`;
export const query_user_permission_byUserCount = `
query countUserPermissions($userId: String!, $aziendaId: Int!) {
  user_permission_aggregate(where: {UserId: {_eq: $userId}, AziendaId: {_eq: $aziendaId}}) {
    aggregate {
      count
    }
  }
}`;
export const query_user_permission_byUser = `
query getUserPermissionByUser($userId: String!, $aziendaId: Int!) {
  user_permission(where: {UserId: {_eq: $userId}, AziendaId: {_eq: $aziendaId}}, order_by: {Id: asc}) {
    Id
    AziendaId
    Area
    CanRead
    CanCreate
    CanUpdate
    CanDelete
  }
}`;
export const query_user_permission_hasTruePermsCount = `
query getUserPermissionHasTruePermsCount($userId: String!, $aziendaId: Int!) {
  user_permission_aggregate(where: {
    UserId: {_eq: $userId}, AziendaId: {_eq: $aziendaId},
    _or: [{CanRead: {_eq: true}}, {CanCreate: {_eq: true}}, {CanUpdate: {_eq: true}}, {CanDelete: {_eq: true}}]
  }
    ) {
      aggregate {
        count
      }
  }
}`;
// Restituisce, in un'unica query, le AziendaId su cui l'utente ha almeno un permesso attivo
// (elimina l'N+1 di CheckAziendaPermissions). Nessun filtro tenant: user_permission non ha
// colonna tenant e il risultato va intersecato con le aziende del tenant a monte (safe).
export const query_user_permitted_aziende = `
query getUserPermittedAziende($userId: String!) {
  user_permission(
    where: {
      UserId: {_eq: $userId},
      _or: [{CanRead: {_eq: true}}, {CanCreate: {_eq: true}}, {CanUpdate: {_eq: true}}, {CanDelete: {_eq: true}}]
    },
    distinct_on: AziendaId
  ) {
    AziendaId
  }
}`;